import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  fire(popup: any) {
    return Swal.fire(popup);
  }

  showValidationMessage(message: string) {
    return Swal.showValidationMessage(message);
  }
}
